import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import { auth, firestore, serverTimestamp, toMillis } from '../lib/firebase';
import { UserContext } from '../lib/context';
import { useRouter } from 'next/router';
import { useState, useEffect, useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import createNewConsultRenew from '../lib/helper/createNewConsultRenew';
import createNewConsultRenewAcne from '../lib/helper/createNewConsultRenewAcne';
import axios from 'axios';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Dashboard() {
  return (
    <>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const router = useRouter();
  const { user } = useContext(UserContext);
  const [prescriptions, setPrescriptions] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  // Function that gets the consult and the patient info
  const getPrescriptions = async () => {
    try {
      const presRef = firestore
        .collection('prescriptions')
        .where('userID', '==', user.uid)
        .orderBy('createdAt', 'desc');
      const snapshot = await presRef.get();
      return snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(async () => {
    if (user && prescriptions) {
      setIsLoaded(true);
      console.log('PRESCRIPTIONS');
      console.log(prescriptions);
      prescriptions.forEach((pres) => console.log(pres.id));
    }
  }, [user, prescriptions]);

  useEffect(async () => {
    if (user) {
      setPrescriptions(await getPrescriptions());
    }
  }, [user]);

  const goCheckout = (p) => {
    router.push(`/checkout/${p.id}`);
  };

  const refillOrRenew = async (prescription) => {
    try {
      const token = await user.getIdToken();
      const newCard = await axios.post(
        '/api/refills/refillOrRenew',
        { prescriptionID: prescription.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      console.log(e);
    }
  };

  const renew = async (prescription) => {
    try {
      const consultID =
        prescription?.consultationID ||
        prescription?.renewals[0]?.consultationID;
      if (prescription.treatment == 'Birth Control') {
        await createNewConsultRenew(user, router, consultID, prescription);
      }
      if (prescription.treatment == 'Acne') {
        await createNewConsultRenewAcne(user, router, consultID, prescription);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const refill = async (prescription) => {
    try {
      const token = await user.getIdToken();
      const newCard = await axios.post(
        '/api/refills/refill',
        { prescriptionID: prescription.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className={`${styles['dashboard-container']} red`}>
      <div className={`${styles['dashboard-container-max']} red`}>
        <div className={`${styles['dashboard-item-title']} red`}>
          My Prescriptions
        </div>
        {!isLoaded && (
          <div className={`${styles['prescriptions-item-container']} red`}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </div>
        )}
        {isLoaded && prescriptions.length == 0 && (
          <div className={`${styles['prescriptions-item-container']} red`}>
            You don&apos;t have any active prescriptions yet.
          </div>
        )}
        {isLoaded && prescriptions.length > 0 && (
          <>
            {prescriptions.map((p, i) => (
              <div
                className={`${styles['prescriptions-item-container']}`}
                key={i}
              >
                <div className={`${styles['consultations-type']} red`}>
                  {p.treatment} Prescription
                </div>

                <div className={`${styles['consultations-date']} red`}>
                  {`Created ${new Date(p.createdAt.toMillis())
                    .toString()
                    .slice(4, 21)}`}
                </div>
                {/* approved --> awaiting confirmation --> confirmed --> insurance requested --> awaiting payment --> active (paid) --> paused */}

                <span className={`${styles['consultations-badge']} red`}>
                  {p.status == 'approved' && 'Being processed'}
                  {p.status == 'awaiting confirmation' &&
                    'Awaiting confirmation'}
                  {p.status == 'confirmed' && 'Being processed'}
                  {p.status == 'insurance requested' && 'Being processed'}
                  {p.status == 'awaiting payment' && 'Awaiting payment'}
                  {p.status == 'paused' && 'Paused'}
                  {p.status == 'active' && 'Active'}
                </span>

                <div className={`${styles['prescription-info']} red`}>
                  {p.molecules.length == 1 && (
                    <div className={`${styles['prescription-info-line']} red`}>
                      Medication: {p.molecules[0].name}
                    </div>
                  )}
                  {p.molecules.length > 1 && (
                    <div className={`${styles['prescription-info-line']} red`}>
                      Medications:{' '}
                      {p.molecules.map((mol, i) => (
                        <span key={i}>{`${i + 1}) ${mol.name}. `}</span>
                      ))}
                    </div>
                  )}

                  {p.molecules.length == 1 && (
                    <div className={`${styles['prescription-info-line']} red`}>
                      Fills: {p.molecules[0].fillsTotal}
                    </div>
                  )}
                  {p.molecules.length > 1 && (
                    <div className={`${styles['prescription-info-line']} red`}>
                      Fills:{' '}
                      {p.molecules.map((mol, i) => (
                        <span key={i}>{`${i + 1}) ${mol.fillsTotal}. `}</span>
                      ))}
                    </div>
                  )}

                  {p.molecules.length == 1 && (
                    <div className={`${styles['prescription-info-line']} red`}>
                      Doctor Notes: {p.molecules[0].directions}
                    </div>
                  )}
                  {p.molecules.length > 1 && (
                    <div className={`${styles['prescription-info-line']} red`}>
                      Doctor Notes:{' '}
                      {p.molecules.map((mol, i) => (
                        <span key={i}>{`${i + 1}) ${
                          mol.directions ? mol.directions : 'none'
                        }. `}</span>
                      ))}
                    </div>
                  )}
                </div>
                {(p.status == 'awaiting payment' ||
                  p.status == 'awaiting confirmation') && (
                  <button
                    className={`${styles['prescription-checkout-btn']} red`}
                    onClick={() => goCheckout(p)}
                  >
                    Go to Checkout
                  </button>
                )}
                {p.renewalWindow && (
                  <div className={`${styles['consultations-links']} red`}>
                    <div
                      className={`${styles['consultations-btn-text-1']} red`}
                      onClick={() => renew(p)}
                    >
                      Renew Prescription
                    </div>
                  </div>
                )}

                {/* {user && user.email.includes('@nana.com') && (
                  <div className={`${styles['consultations-links']} red`}>
                    <div
                      className={`${styles['consultations-btn-text-1']} red`}
                      onClick={() => refill(p)}
                    >
                      Refill Prescription
                    </div>
                  </div>
                )}
                {user && user.email.includes('@nana.com') && (
                  <div className={`${styles['consultations-links']} red`}>
                    <div
                      className={`${styles['consultations-btn-text-1']} red`}
                      onClick={() => renew(p)}
                    >
                      Renew Prescription
                    </div>
                  </div>
                )} */}
                {user && user.email.includes('@nana.com') && (
                  <div className={`${styles['consultations-links']} red`}>
                    <div
                      className={`${styles['consultations-btn-text-1']} red`}
                      onClick={() => refillOrRenew(p)}
                    >
                      Refill or Renew Prescription
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        )}

        <NavbarMobile />
      </div>
    </div>
  );
}
